import React from "react";
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table,
} from '@material-ui/core';

const cellCommonStyle = { border: '1px solid #e0e0e0', padding: '2px', paddingLeft: '5px', paddingRight: '5px' };

export default class ComponentToPrint extends React.Component {
  render() {
    const selectedSearchValues = this.props.selectedSearchValues;
    const GroupList = this.props.GroupList;
    const FactoryList = this.props.FactoryList;
    const RouteList = this.props.RouteList;
    const reportData = this.props.reportData;
    const totalAmount = this.props.totalAmount;
    return (
      <div>
        <div>&nbsp;</div>
        <div className="row pl-2 pb-4 pt-4">
          <h4><center>
            Group: &nbsp;{(GroupList && GroupList[selectedSearchValues.groupID]) || ''}
          </center></h4>
          <h4><center>
            Factory: &nbsp;{(FactoryList && FactoryList[selectedSearchValues.factoryID]) || ''}
          </center></h4>
          <h4><center>
            Route: &nbsp;{(selectedSearchValues.routeID == 0 || selectedSearchValues.routeID == "0" ? "All Routes" : RouteList[selectedSearchValues.routeID])}
          </center></h4>
          <h4><center>
            Reg No: &nbsp;{(selectedSearchValues.registrationNumber === '' || selectedSearchValues.registrationNumber === null ? "All Registration Numbers" : selectedSearchValues.registrationNumber)}
          </center></h4>
          <h4><center>
            {selectedSearchValues.fromDate} to {selectedSearchValues.toDate}
          </center></h4>
          <div>&nbsp;</div>
        </div>
        <div>
          <Box minWidth={650}>
            <TableContainer style={{ border: '1px solid #e0e0e0', borderRadius: 4, marginTop: 16 }}>
              <Table size="small" aria-label="report table" style={{ borderCollapse: 'collapse', width: '100%' }}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ ...cellCommonStyle, width: 120 }} align="center"><b>Route</b></TableCell>
                    <TableCell style={{ ...cellCommonStyle, width: 80 }} align="center"><b>Reg No</b></TableCell>
                    <TableCell style={{ ...cellCommonStyle, width: 200 }} align="center"><b>Name</b></TableCell>
                    <TableCell style={{ ...cellCommonStyle, width: 120 }} align="center"><b>Payment Effective Month</b></TableCell>
                    <TableCell style={{ ...cellCommonStyle, width: 120 }} align="center"><b>No. of Installment</b></TableCell>
                    <TableCell style={{ ...cellCommonStyle, width: 140 }} align="center"><b>Requested Date</b></TableCell>
                    <TableCell style={{ ...cellCommonStyle, width: 140 }} align="center"><b>Approved Date</b></TableCell>
                    <TableCell style={{ ...cellCommonStyle, width: 100 }} align="center"><b>Amount</b></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reportData.map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell style={{ ...cellCommonStyle, width: 120 }} align="left">{row.routeName}</TableCell>
                      <TableCell style={{ ...cellCommonStyle, width: 80 }} align="left">{row.regNumber}</TableCell>
                      <TableCell style={{ ...cellCommonStyle, width: 200 }} align="left">{row.fullName}</TableCell>
                      <TableCell style={{ ...cellCommonStyle, width: 120 }} align="left">{row.effectiveMonth}</TableCell>
                      <TableCell style={{ ...cellCommonStyle, width: 120 }} align="left">{row.numberOfInstallment}</TableCell>
                      <TableCell style={{ ...cellCommonStyle, width: 140 }} align="center">{row.requestedDate}</TableCell>
                      <TableCell style={{ ...cellCommonStyle, width: 140 }} align="center">{row.approvedDate}</TableCell>
                      <TableCell style={{ ...cellCommonStyle, width: 100 }} align="right">{row.amount}</TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell colSpan={7} style={{ border: '1px solid #e0e0e0', textAlign: 'left', padding: '8px' }}>
                      <b>Total</b>
                    </TableCell>
                    <TableCell style={{ border: '1px solid #e0e0e0', textAlign: 'right', padding: '8px' }}>
                      <b>{totalAmount.toFixed(2)}</b>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}